import React from "react";
import { useSettings } from "../contextapi/SettingsContext";
import { resolveHeroContent } from "../constants/heroContent";
import defaultHero from "../assets/images/hero.jpg";
import HeroSection from "./HeroSection";

const Heropage = () => {
  const settings = useSettings();
  const content = resolveHeroContent(settings);
  const heroSrc = settings.heroSectionImageUrl || defaultHero;

  return (
    <HeroSection
      headline={content.headline}
      body={content.body}
      headlineColor={content.headlineColor}
      imageSrc={heroSrc}
      ctaLabel={content.ctaLabel}
      ctaUrl={content.ctaUrl}
    />
  );
};

export default Heropage;
